<script>
  import { modal } from 'vue-strap';
  import liberarPagamento from '../servico';
  import { iconeStatus } from '../status';

  export default {
    components: { modal },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      id: {
        default: null,
      },
      podeLiberar: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        detalhe: null,
        carregando: false,
        liberando: false,
      }
    },
    methods: {
      carregar() {
        if (!this.id) return;

        this.carregando = true;
        this.detalhe = null;

        return liberarPagamento
          .detalhe(this.id)
          .then(detalhe => {
            this.detalhe = detalhe;
            this.carregando = false;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar os dados do lançamento.');
          });
      },
      limpar() {
        this.detalhe = null;
        this.carregando = false;
        this.liberando = false;
      },
      bordaDestaque(index, coluna) {
        if (index >= this.quantidadeDestacada) return null;

        const borda = '2px solid #8fd9c8';
        const estilo = {};

        if (index === 0) estilo.borderTop = borda;
        if (index === this.quantidadeDestacada - 1) estilo.borderBottom = borda;
        if (coluna === 0) estilo.borderLeft = borda;
        if (coluna === 4) estilo.borderRight = borda;

        return estilo;
      },
      iconeStatus,
      liberar() {
        this.$emit('liberar', this.detalhe);
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
      mostrarBotaoLiberar() {
        return this.podeLiberar && this.detalhe && this.detalhe.podeLiberar;
      },
      quantidadeDestacada() {
        if (!this.detalhe || !this.detalhe.rateios) return 0;

        if (!this.detalhe.liberarTodos) return 1;

        return this.detalhe.rateios.filter(rateio => !rateio.agrupado).length;
      },
      textoBotaoLiberar() {
        return this.detalhe && this.detalhe.liberarTodos ? 'Liberar todos' : 'Liberar este rateio';
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           :large="true"
           :backdrop="false"
           @opened="carregar"
           @closed="limpar(), $emit('fechado')">
      <div slot="modal-header" class="modal-header">Dados do lançamento</div>

      <div v-if="carregando" class="text-center">
        <i class="fa fa-spinner fa-pulse"></i> Carregando...
      </div>

      <div v-if="detalhe && !carregando">
        <div class="row">
          <div class="col-xs-3">
            <label class="control-label block">Lançamento</label>
            <p class="form-control-static">{{ detalhe.idLancamento }}</p>
          </div>
          <div :class="detalhe.usaDataPrevisao ? 'col-xs-2' : 'col-xs-3'">
            <label class="control-label block">Emissão</label>
            <p class="form-control-static">{{ detalhe.dataEmissao | formatarData('---') }}</p>
          </div>
          <div :class="detalhe.usaDataPrevisao ? 'col-xs-2' : 'col-xs-3'">
            <label class="control-label block">Vencimento</label>
            <p class="form-control-static">{{ detalhe.dataVencimento | formatarData('---') }}</p>
          </div>
          <div class="col-xs-2" v-if="detalhe.usaDataPrevisao">
            <label class="control-label block">Previsão</label>
            <p class="form-control-static">{{ detalhe.dataPrevisao | formatarData('---') }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Pagamento</label>
            <p class="form-control-static">{{ detalhe.dataPagamento | formatarData('---') }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-6">
            <label class="control-label block">Beneficiário</label>
            <p class="form-control-static">{{ detalhe.beneficiario || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">CPF / CNPJ</label>
            <p class="form-control-static">{{ detalhe.cpfCnpj || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Conta</label>
            <p class="form-control-static">{{ detalhe.nomeConta || '---' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-6">
            <label class="control-label block">Histórico</label>
            <p class="form-control-static">{{ detalhe.historico || '---' }}</p>
          </div>
          <div class="col-xs-6">
            <label class="control-label block">Complemento</label>
            <p class="form-control-static">{{ detalhe.complemento || '---' }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-3">
            <label class="control-label block">Documento</label>
            <p class="form-control-static">{{ detalhe.documento || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Documento receber/pagar</label>
            <p class="form-control-static">{{ detalhe.documentoReceberPagar || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Nota fiscal</label>
            <p class="form-control-static">{{ detalhe.documentoNotaFiscal || '---' }}</p>
          </div>
          <div class="col-xs-3">
            <label class="control-label block">Valor do lançamento</label>
            <p class="form-control-static">{{ detalhe.valorLancamento | formatarNumero }}</p>
          </div>
        </div>

        <div class="table-responsive m-t-md">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Projeto</th>
                <th>Rubrica</th>
                <th>Subrubrica</th>
                <th class="text-right">Valor</th>
                <th>Situação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rateio, index) in detalhe.rateios"
                  :class="{ 'rateio-destacado': index < quantidadeDestacada, 'rateio-agrupado': rateio.agrupado, 'rateio-sem-acesso': rateio.semAcesso }">
                <td :style="bordaDestaque(index, 0)">{{ rateio.nomeProjeto || '---' }}</td>
                <td :style="bordaDestaque(index, 1)">{{ rateio.nomeRubrica || '---' }}</td>
                <td :style="bordaDestaque(index, 2)">{{ rateio.nomeSubrubrica || '---' }}</td>
                <td class="text-right" :style="bordaDestaque(index, 3)">{{ rateio.valor | formatarNumero }}</td>
                <td :style="bordaDestaque(index, 4)" :class="{ 'text-danger': rateio.statusCodigo === 2 }">
                  <i v-if="rateio.statusCodigo" :class="['status-icone', iconeStatus(rateio.statusCodigo)]"></i>
                  {{ rateio.descricaoSituacao || '---' }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="3">Total dos rateios</th>
                <th class="text-right">{{ detalhe.totalRateios | formatarNumero }}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div v-if="!detalhe && !carregando" class="text-center">
        Nenhum dado encontrado para este lançamento.
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button type="button"
                class="btn btn-primary"
                v-if="mostrarBotaoLiberar"
                :disabled="liberando"
                @click="liberar">
          <i class="fa fa-check"></i> {{ textoBotaoLiberar }}
        </button>
        <button type="button"
                class="btn btn-default"
                :disabled="liberando"
                @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>

<style scoped>
  .rateio-destacado td {
    font-weight: 600;
    background-color: #f5fcfa;
  }

  .status-icone {
    font-size: 1.35em;
    vertical-align: middle;
  }

  .status-aguardando {
    color: #f8ac59;
  }

  .status-vencido {
    color: #ed5565;
  }

  .status-liberado {
    color: #1c84c6;
  }

  .status-pago {
    color: #1d9d74;
  }

  .rateio-agrupado td {
    font-style: italic;
  }

  .rateio-sem-acesso td {
    color: #8a8a8a;
  }

  .form-control-static {
    margin-bottom: 10px;
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pagamento/componentes/ModalDetalheLancamento.vue